
import { APP_RETIREMENT_URLS } from "../../const/AppConst";
import { staticBaseUrl } from "../../config/GlobalConfig";
import useAppState from "../../context/AppContext";
import MenuREItem from "../../components/retirement/menuREItem";
import { isDoneProposition } from "../../utils/dataUtils";


type RESidePannelRetirementBloc = {
  isActive ?: boolean
}
export default function RESidePannelRetirementBloc({isActive}: Readonly<RESidePannelRetirementBloc>) {
  const {
    state: { infoSteps, isConseiller, proposition, reviewMode}
  } = useAppState();

  const isDone = proposition && isDoneProposition(proposition!);

  let styledClass = "adherent-lateralnav lateral-nav bg-blanc shadow-bleu";
  if(isActive === false)  styledClass += ' unactive';

  return (
    <aside className={styledClass}>
      <img src={staticBaseUrl + "/img/mgp.svg"} alt="MGP" className="m-x-xl m-y-lg ta-center sc-appear-fromtop logo isreveal"/>
    
      <div className="hide-in-mobile">
          {
              isConseiller && isDone && 
              <div>
                <MenuREItem label='Récapitulatif' name="" path={APP_RETIREMENT_URLS.retirementRecapPage} state="conseiller-active"/>
                {proposition?.configuration?.hasSignature && <MenuREItem label='Documents signés' name="" path={APP_RETIREMENT_URLS.infoSignatureDonePage} state="conseiller-active"/>}
                <MenuREItem label='Justificatifs' name="" path={APP_RETIREMENT_URLS.listInvalidDocumentPage} state="conseiller-active"/>  
                <MenuREItem label='Correctif des informations' name="" path={APP_RETIREMENT_URLS.infoModificationPage} state="conseiller-active"/>
              </div>
          }
        
         { (!isConseiller || !isDone) && 
          <div>
            <MenuREItem label='Je renseigne ma situation' name="SITUATION" path={APP_RETIREMENT_URLS.situationPage}/>
          
            <MenuREItem label="Je définis mes besoins" name="BESOIN" path={APP_RETIREMENT_URLS.besoinPage}
            />
        
            <MenuREItem label="Je choisis ma couverture"name="GUARANTY" path={APP_RETIREMENT_URLS.guarantyPage}
            />
        
            {reviewMode ?
              <MenuREItem label="J'adhère" name="INFO" path={APP_RETIREMENT_URLS.infoIdentityPage} subMenuItems={infoSteps.filter(step => step.category === 'INFO')}
              />
              :
              <MenuREItem  label="J'adhère" name="INFO" path={APP_RETIREMENT_URLS.infoIdentityPage}
                subMenuItems={infoSteps.filter(step => step.category === 'INFO' && !step.reviewMode)}
              />
            }
          </div>
          }
      </div>
      
     
    </aside>
  )
}
